import './error404.less'

import fallbackImage from 'assets/images/hero.jpg'
import futureSummitsLogoWhite from 'assets/images/logos/futuresummits-logo-white.svg'
import React, {Component} from 'react'
import {useEvent} from 'util/eventcontext'
import {t} from 'util/i18n'
import {style} from 'util/style'
import {EventLogo} from 'views/layout/eventlogo'
import {Theme} from 'views/theme'

const styles = style('error404')

export const Error404: React.FC = () => {
	const event = useEvent()

	return (
		<div
			className={styles()}
			style={{
				backgroundImage: `url('${event.background?.src || fallbackImage.src}')`
			}}
		>
			<div className={styles('overlay')} />
			<Theme.OuterContainer>
				<Theme.Container>
					<div className={styles('content')}>
						{/* <img
							{...futureSummitsLogoWhite}
							className={styles('content-logo')}
						/> */}
						<div className={styles('content-logo')}>
							<EventLogo event={event} white={true} />
						</div>
						<div className={styles('content-title')}>
							<h1>{t('error404.title')}</h1>
						</div>
						<div className={styles('content-subtitle')}>
							<h2>{t('error404.subtitle')}</h2>
						</div>
						<Theme.Wysiwyg className={styles('content-text')}>
							{t('error404.text')}
						</Theme.Wysiwyg>
						<Theme.Button
							className={styles('content-button').mod('arrowlong')}
							to={event.url}
						>
							<Theme.ButtonText>{t('error404.btn')}</Theme.ButtonText>
							<Theme.ButtonIcon icon="arrow-long" />
						</Theme.Button>
					</div>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}
